import React from 'react'
import { Button } from '../../../lib/ui/button'
import CalendlyEventInfo from './CalendlyEventInfo'
import { cn } from '../../../lib/utils'
import { useBenefits } from '../../coach_services/BenefitsProvider'
import { useTranslation } from '../../../hooks/useTranslation'
import { ReactFeedbackDialog } from './FeedbackDialog'

export default function MeetingInfo({
  calendlyEvent,
  eventName,
  requestType,
  buttonText,
  requestComplete,
  dashboardCard,
  cardTitle,
  flexResumeReview,
  introCallScheduled,
  meetingViaCalendly,
  buttonVariant,
  buttonUrl,
  ...props
}) {
  const {
    onScheduleClick,
    coach,
    onFeedbackClick,
    setShowReactFeedbackDialog,
    select,
  } = useBenefits()
  const { t } = useTranslation('service_card')
  const showReactFeedbackDialogTypes = [
    'ServiceRequest::JobSearchStrategy',
    'ServiceRequest::InterviewPrep',
    'ServiceRequest::JobSearchBurnout',
    'ServiceRequest::CareerPivotPlanning',
    'ServiceRequest::ExecutiveBio',
    'ServiceRequest::RecruiterTargeting',
    'ServiceRequest::BoardSearch',
  ]
  const availableRequestTypes = [
    'ServiceRequest::OrientationCall',
    'ServiceRequest::LinkedInReview',
    'ServiceRequest::ResumeReview',
  ].concat(showReactFeedbackDialogTypes)

  const variant = select ? 'outline' : 'coachcta'

  const ctaDisabled =
    !flexResumeReview && !availableRequestTypes.includes(requestType)

  if (introCallScheduled && !dashboardCard) return null

  if (requestComplete && showReactFeedbackDialogTypes.includes(requestType)) {
    return (
      <div className="flex flex-col gap-4">
        <div className="!font-medium">
          {t('service_complete', { service_name: eventName })}
        </div>
        <div className={cn('', dashboardCard ? 'w-full' : '')}>
          <ReactFeedbackDialog requestType={requestType}>
            <Button
              variant={buttonVariant || variant}
              className={cn('', dashboardCard ? 'w-full' : '')}
            >
              {t('view_feedback')}
            </Button>
          </ReactFeedbackDialog>
        </div>
      </div>
    )
  }

  if (requestComplete && requestType === 'ServiceRequest::JobSearchStrategy') {
    return (
      <div className="flex flex-col gap-4">
        <div className="!font-medium">
          {t('service_complete', { service_name: eventName })}
        </div>
        <div className={cn('', dashboardCard ? 'w-full' : '')}>
          <ReactFeedbackDialog requestType={requestType} />
          <Button
            variant={buttonVariant || variant}
            className={cn('', dashboardCard ? 'w-full' : '')}
            onClick={() => {
              setShowReactFeedbackDialog(true)
            }}
          >
            {t('view_feedback')}
          </Button>
        </div>
      </div>
    )
  }

  if (requestComplete && !flexResumeReview) {
    return (
      <div className="flex flex-col gap-4">
        <div className="!font-medium">
          {t('service_complete', { service_name: eventName })}
        </div>
        <div className={cn('', dashboardCard ? 'w-full' : '')}>
          <Button
            variant={buttonVariant || variant}
            onClick={() => onFeedbackClick(requestType)}
            className={cn('', dashboardCard ? 'w-full' : '')}
          >
            {t('view_feedback')}
          </Button>
        </div>
      </div>
    )
  } else if (requestComplete && flexResumeReview) {
    return <></>
  } else if (calendlyEvent && calendlyEvent['start_time']) {
    return (
      <CalendlyEventInfo
        eventName={eventName}
        calendlyEvent={calendlyEvent}
        dashboardCard={dashboardCard}
        {...props}
      />
    )
  } else if (meetingViaCalendly === false) {
    return <p className="!font-medium">{t('request_submitted_body')}</p>
  } else {
    return (
      <Button
        variant={buttonVariant || variant}
        onClick={() =>
          onScheduleClick(
            requestType,
            cardTitle,
            true,
            flexResumeReview ? 2 : 1,
          )
        }
        className={cn('', dashboardCard ? 'w-full' : '')}
        disabled={ctaDisabled || coach.isLiaison}
      >
        {buttonText}
      </Button>
    )
  }
}
